import { db, LocalUser } from '@/shared/lib/db'
import { initializeLocalData } from '@/shared/lib/dbSync'
import { auth } from '../services/firebaseAuth'
import { onAuthStateChanged } from '@firebase/auth'

import { useEffect } from 'react'
import { useAuthStore } from '../stores/auth.store'

// This component now just initializes the auth listener
// It doesn't need to wrap children with a Context Provider anymore
export const AuthListener = ({ children }: { children: React.ReactNode }) => {
    const { setUser, setLoading } = useAuthStore()

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
            if (firebaseUser) {
                const userData = {
                    uid: firebaseUser.uid,
                    email: firebaseUser.email,
                    displayName: firebaseUser.displayName ?? undefined,
                }
                await db.users.put(userData)
                const dbSynced = localStorage.getItem('dbSynced')
                if (!dbSynced) {
                    initializeLocalData(firebaseUser.uid)
                    localStorage.setItem('dbSynced', 'true')
                }
                setUser(userData)
                setLoading(false)
            } else {
                setUser(null)
                setLoading(false)
            }
        })

        return () => unsubscribe()
    }, [setUser, setLoading])

    return <>{children}</>
}

// Re-export useAuth from the store for consumer compatibility
export { useAuth } from '../stores/auth.store'

